/* eslint-disable */
/* ***********************************************************
* A short word on how to use this automagically generated file.
* We're often asked in the ignite gitter channel how to connect
* to a to a third party api, so we thought we'd demonstrate - but
* you should know you can use sagas for other flow control too.
*
* Other points:
*  - You'll need to add this saga to sagas/index.js
*  - This template uses the api declared in sagas/index.js, so
*    you'll need to define a constant in that file.
*************************************************************/

import { call, put } from 'redux-saga/effects'
import KargoeCareActions from '../Redux/KargoeCareRedux'
// import { KargoeCareSelectors } from '../Redux/KargoeCareRedux'

export function* getKargoeCare(api, action) {
  try {
    const cacheName = 'charityList'
    const charities = api.cacheGet(cacheName)
    if (charities) {
      yield put(KargoeCareActions.kargoeCareSuccess(charities))
      return
    }
    const response = yield call(api.getCharities, {})
    if (response.ok) {
      // You might need to change the response here - do this with a 'transform',
      // located in ../Transforms/. Otherwise, just pass the data back from the api.
      const charities = response.data.data
      api.cacheSet(cacheName, charities, 3600) // one hour
      yield put(KargoeCareActions.kargoeCareSuccess(charities))
    } else {
      yield put(KargoeCareActions.kargoeCareFailure())
    }
  } catch (e) {
    yield put(KargoeCareActions.kargoeCareFailure())
  }
}
